<template>
    <div class="_activity sub_page">
        <section class="sub_page_con wrap_1120">
            <div class="total_num">
                <span>Total</span>
                <span class="total_num_value">{{ state.totalLength }}</span>
            </div>
            <div class="btn_wrap _default right_btn _board_type" v-if="state.hasAuth">
                <button type="button" class="common_btn _gray" @click="isDelete">삭제</button>
                <router-link class="common_btn w_130" :to="{ name: 'EventWrite' }">글쓰기</router-link>
            </div>
            <div class="con_gal sub_page_con_view">
                <ul>
                    <li
                        class="checkbox_wrap"
                        v-for="item in state.list"
                        :key="item.idx"
                        :class="[item.applyState === 1 ? 'done' : 'active']"
                        v-if="state.list.length > 0"
                    >
                        <template v-if="!state.isMobile">
                            <label :for="item.idx" class="gal_tag">
                                <template v-if="state.hasAuth">
                                    <input type="checkbox" name="chk" :id="item.idx" @click="selectedIdx(item.idx)" />
                                    <em></em>
                                </template>
                                <span class="" v-if="item.applyState === 1">완료</span>
                                <span class="" v-else>미완료</span>
                            </label>

                            <!--진행전이 default/ 진행중 active, 진행완료 done-->
                            <router-link :to="{ name: 'EventView', params: { id: item.idx } }">
                                <div class="img_wrap">
                                    <img v-if="item.thumbnail" :src="item.thumbnail" alt="" />
                                    <img v-else src="img/no_img1.png" alt="" />
                                </div>
                                <div class="desc_wrap">
                                    <p class="con_tit elips_2" v-text="item.title"></p>
                                    <p class="con_desc elips_3" v-html="CommonUtils.decodeContent(item.content).replace(/<img[^>]*>/gi, '')"></p>
                                    <p class="con_date">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</p>
                                    <div class="con_info">
                                        <!-- <p v-if="item.activeStartDate && item.activeEndDate">
                                            <span class="info_tit">활동기간</span>
                                            <span class="info_data">
                                                {{
                                                    CommonUtils.dateFormat(new Date(item.activeStartDate), ".", false) +
                                                    "-" +
                                                    CommonUtils.dateFormat(new Date(item.activeEndDate), ".", false)
                                                }}
                                            </span>
                                        </p>
                                        <p v-if="item.recruitStartDate && item.recruitEndDate">
                                            <span class="info_tit">모집기간</span>
                                            <span class="info_data">
                                                {{
                                                    CommonUtils.dateFormat(new Date(item.recruitStartDate), ".", false) +
                                                    "-" +
                                                    CommonUtils.dateFormat(new Date(item.recruitEndDate), ".", false)
                                                }}
                                            </span>
                                        </p> -->
                                        <p v-if="item.applyDate">
                                            <span class="info_tit">신청 마감</span>
                                            <span class="info_data">
                                                {{ CommonUtils.dateFormat(new Date(item.applyDate), ".", false) }}
                                            </span>
                                        </p>
                                        <p v-if="item.cntApply > 0">
                                            <span class="info_tit">모집인원</span>
                                            <span class="info_data">{{ CommonUtils.numberFormat(item.cntApply) }}명</span>
                                        </p>
                                        <!-- <p>
                                            <span class="info_tit">장소</span>
                                            <span class="info_data">{{ item.address }} {{ item.addressDetail }}</span>
                                        </p> -->
                                    </div>
                                </div>
                            </router-link>
                        </template>
                        <template v-else>
                            <label :for="item.idx" class="gal_tag">
                                <template v-if="state.hasAuth">
                                    <input type="checkbox" name="chk" :id="item.idx" @click="selectedIdx(item.idx)" />
                                    <em></em>
                                </template>
                                <span class="" v-if="item.applyState === 1">완료</span>
                                <span class="" v-else>미완료</span>
                            </label>
                            <router-link :to="{ name: 'EventView', params: { id: item.idx } }">
                                <div class="img_wrap">
                                    <img v-if="item.thumbnail" :src="item.thumbnail" alt="" />
                                    <img v-else src="img/no_img1.png" alt="" />
                                </div>
                                <div class="desc_wrap">
                                    <p class="con_tit elips_2" v-text="item.title"></p>
                                </div>
                            </router-link>
                        </template>
                    </li>
                    <li v-else class="tbody_li no_data">
                        <div class="tr_div">
                            <div class="tb_subject" style="text-align: center; width: 100%">등록된 게시물이 없습니다.</div>
                        </div>
                    </li>
                </ul>
            </div>

            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                @onPaging="handlePageChange"
            ></PageBtn>
        </section>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        apiService,
        types,
        CommonUtils,
        PageBtn,
        onBeforeMount,
        userStore,
        ModalDefault,
        getMessageByCode,
    } from "@/BaseComponent";

    export default {
        components: { PageBtn, ModalDefault },
        setup() {
            const global = globalStore();
            const user = userStore();
            const state = reactive({
                tab: 0 as number,

                list: [] as Array<any>,

                searchType: "" as string,
                searchText: "" as string,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                page: 1 as number,
                size: 4 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                hasAuth: false as boolean,

                idxList: [] as Array<number>,

                isMobile: false,
            });

            onBeforeMount(() => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin && user.roles != null && user.roles.some((item: types.RoleVO) => item.key.indexOf("event") > -1)))
                )
                    state.hasAuth = true;
            });

            onMounted(() => {
                getList();

                state.isMobile = window.innerWidth < 768;
            });

            const getList = async () => {
                const param: types.ReqBoardList = {
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,
                };
                const res: types.ResReportList = await apiService.boardEvent.list(param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;

                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const selectedIdx = (idx: number) => {
                if (state.idxList.indexOf(idx) > -1) state.idxList.splice(state.idxList.indexOf(idx), 1);
                else state.idxList.push(idx);
            };

            const closeModal = () => {
                state.isShowModal = false;
                getList();
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    remove();
                } else {
                    getList();
                }
            };

            const isDelete = () => {
                if (state.idxList.length === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = "삭제하고자 하는 시민활동을 선택해주세요.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                }
            };

            const remove = async () => {
                if (state.idxList.length === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = "삭제하고자 하는 캠페인·이벤트를 선택해주세요.";
                    state.isShowModal = true;
                } else {
                    const param: types.ReqIdxList = {
                        idxList: state.idxList.join(","),
                    };
                    const res = await apiService.boardEvent.removeList(param);

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "삭제 성공";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                        state.idxList = [];

                        getList();
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            return { state, router, handlePageChange, getList, CommonUtils, isDelete, selectedIdx, closeModal, callBackModal };
        },
    };
</script>
